<!-- Content -->
<div class="content container-fluid">
  <!-- Page Header -->
  <header class="page-header">
    <nav attr.aria-label="{{ 'wcag.breadcrumb' | translate }}">
      <ol class="breadcrumb">
        <breadcrumb></breadcrumb>
      </ol>
    </nav>

    <div class="page-header-grid grid-sm">
      <h1 class="page-header-title" id="raffleTitle">
        {{ 'raffleModule.raffles' | translate }}
      </h1>

      <div>
        <button
          class="btn btn-primary"
          (click)="onClickCreate()"
          [canSee]="[accessRights.Raffle_write]"
          type="button"
        >
          {{ 'general.create' | translate }}
        </button>
      </div>
    </div>
  </header>
  <!-- End Page Header -->
  <!-- Nav -->
  <div class="d-flex">
    <dms-switch
      [textItem1]="'general.active'"
      [textItem2]="'general.inactive'"
      [responseItem1]="true"
      [responseItem2]="false"
      (onEmitItem1)="form.controls['isActive'].patchValue($event)"
      (onEmitItem2)="form.controls['isActive'].patchValue($event)"
    >
    </dms-switch>
  </div>

  <!-- End Nav -->

  <div class="w-100">
    <section class="card" aria-labelledby="raffleTitle">
      <raffle-table
        [tableData]="raffles$ | async"
        [sortOrder]="sortOrder"
        [key]="key"
        (onBulkAction)="onBulkAction($event)"
        (onClickRow)="onClickRow($event)"
        [showTotal]="true"
        [removeSearchTerm$]="removeSearchTerm$.asObservable()"
        [showPageFooter]="true"
        [limitPage]="limit"
        [activePage]="page"
        [total]="total"
        [pageCount]="pageCount"
        (onSortedTable)="onSortedTable($event)"
        (searchTerm)="onSearchTerm($event)"
        (onSelectedPage)="selectNewPage($event)"
        (onSelectLimit)="selectNewLimit($event)"
        (onSearchTerm)="onSearchTerm($event)"
      ></raffle-table>
    </section>
  </div>
</div>
